/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Packs_RedirectingInputs */

const en_directory_ai_tools_packs_redirecting = /** @type {(inputs: Directory_Ai_Tools_Packs_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting…`)
};

const zh_directory_ai_tools_packs_redirecting = /** @type {(inputs: Directory_Ai_Tools_Packs_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在跳转…`)
};

/**
* | output |
* | --- |
* | "Redirecting…" |
*
* @param {Directory_Ai_Tools_Packs_RedirectingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_redirecting = /** @type {((inputs?: Directory_Ai_Tools_Packs_RedirectingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_RedirectingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_redirecting(inputs)
	return zh_directory_ai_tools_packs_redirecting(inputs)
});
export { directory_ai_tools_packs_redirecting as "directory.ai_tools.packs.redirecting" }